export default "__VITE_PUBLIC_ASSET__ba46c4e3__"